angular
    .module('tradersyard')
    .factory('graph-term-storage', [
        'graph-group-factory',
        '$rootScope',
        function ($client, $root) {
            var params = {
                page: 0,
                filter: 'my',
            };

            var groups = [],
                categories = [],
                init = false,
                process = false;

            var $http = {
                group: function (after) {
                    ++params.page;
                    $client.query('me', { params: params }).then(function (response) {
                        if (response.data.state === 0 && response.data.data.length > 0) {
                            groups = groups.concat(response.data.data);
                            $http.group(after);
                        } else if (response.data.state === 0) {
                            if (after) after(groups, categories, 1);
                            init = true;
                            process = false;
                        }
                    });
                },
                load: function (finish) {
                    process = true;
                    $client.categories().then(function (response) {
                        if (response.data.state === 0) {
                            categories = response.data.data;
                        }
                    });

                    $http.group(finish);
                },
            };

            return {
                load: function (finish) {
                    if (init === false && process === false) {
                        $http.load(finish);
                    } else if (init === true && process === false) {
                        finish(groups, categories, 2);
                    } else {
                        $root.$watch(
                            function () {
                                return init;
                            },
                            function (state) {
                                if (state) finish(groups, categories, 3);
                            }
                        );
                    }
                },
            };
        },
    ])
    .directive('feedTermForm', [
        '$parse',
        'graph-term-storage',
        'graph-group-factory',
        '$timeout',
        '$rootScope',
        function ($parse, $storage, $group, $timeout, $root) {
            return {
                scope: true,
                link: function ($scope, $element, $attr) {
                    var $walk = function ($array, $call) {
                        for (var i = 0; i < $array.length; i++) {
                            $call($array[i]);

                            if ($array[i].categories.length > 0) $walk($array[i].categories, $call);
                        }
                    };

                    $scope.params = {
                        page: 0,
                        space: 'my',
                    };

                    $scope.categories = [];
                    $scope.groups = [];

                    $scope.filter = {
                        categories: [],
                        groups: [],
                        select: {
                            group: {
                                all: false,
                            },
                        },
                    };

                    $scope.$http = {
                        load: function () {
                            $storage.load(function (groups, categories, im) {
                                $scope.groups = groups;
                                $scope.categories = categories;

                                for (var i = 0; i < $scope.groups.length; i++) {
                                    $scope.filter.groups[$scope.groups[i].id] = false;
                                }
                            });
                        },
                    };

                    $scope.query = {
                        group: [],
                        compile: function () {
                            $scope.query.group = [];
                            $scope.query.attach = [];

                            for (var ix in $scope.groups) {
                                var group = $scope.groups[ix];

                                if ($scope.filter.groups[group.id] === true && $scope.fn.group.filter(group))
                                    $scope.query.group.push(group.id);
                            }

                            $root.$broadcast('post-form-update', $parse($attr.feedTermId)($scope), $scope.query.group);
                        },
                    };

                    $scope.$on('post-form-select', function (e, id, groups) {
                        if (id !== $parse($attr.feedTermId)($scope)) return;

                        angular.forEach(groups, function (group) {
                            $scope.filter.groups[group] = true;
                            $scope.filter.select.group.all = true;
                        });
                        $scope.query.compile();
                    });

                    $scope.fn = {
                        category: {
                            change: function ($node, $selected, $tree) {
                                $scope.filter.categories = [];

                                $walk($tree, function ($node) {
                                    if ($node.selected === true) $scope.filter.categories.push($node.id);
                                });

                                $scope.query.compile();
                            },
                        },
                        group: {
                            all: function () {
                                for (var id in $scope.filter.groups)
                                    $scope.filter.groups[id] = $scope.filter.select.group.all;

                                $scope.query.compile();
                            },
                            change: function ($id) {
                                $scope.filter.select.group.all = false;

                                for (var ix in $scope.groups) {
                                    var group = $scope.groups[ix];

                                    if ($scope.filter.groups[group.id] === true && $scope.fn.group.filter(group)) {
                                        $scope.filter.select.group.all = true;
                                        break;
                                    }
                                }

                                $scope.query.compile();
                            },
                            filter: function ($group) {
                                var $collection = $scope.filter.categories;

                                return $collection.length === 0 || $collection.indexOf($group.category.id) !== -1;
                            },
                        },
                    };

                    $timeout(function () {
                        $scope.$http.load();
                        $scope.fn.group.all();
                    });
                },
            };
        },
    ]);
